import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { accountApiUsage_template } from "../components/templates/accountApiUsage_template";

declare var ko: any;
declare var page: any;

export class accountApiUsage extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected accountApiUsage_template: accountApiUsage_template;

    protected getModuleName(){

        return "accountApiUsage";
    }

    buildContent() : Array<Element>{

        // create the accountApiUsage list
        this.accountApiUsage_template = new accountApiUsage_template("accountApiUsage", this.viewModel, this);
        this.template = this.accountApiUsage_template;

        return [this.accountApiUsage_template.build()];
    }

    fillPage() : void{

        this.getPermissions();
        this.getSearchPresetsListData();
        this.accountApiUsage_template.buildDatePickerCalendar();
    }

    protected getPermissions(){

        this.loadingIn(this.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));

        let accPermissions_url: string = '/api/settings/menuData';
        let accPermissions_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(accPermissions_url, accPermissions_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPermissionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetPermissionsReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.loadingOut(obj.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));
                obj.accountApiUsage_template.setSideMenuPermissionsData(responseParsed);
            })
        }
    }

    protected getListFormData(): void{

        this.loadingIn(this.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));

        let subViewModel = this.accountApiUsage_template.getViewModelForRequest();

        let usrReq_url: string = '/api/settings/api/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj): Function {

        return function() {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();
                obj.getLogsTable();
                obj.getLogsGraph();
            });

            obj.loadingOut(obj.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));
        }
    }

    /**
     * Update the filters.
     *
     * @param responseParsed
     */
    protected updateFilters(responseParsed: any): void {

        this.accountApiUsage_template.setEndpointDropdown(responseParsed.endpoints);
    }

    public getListData(): void{

        this.loadingIn(this.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));

        let subViewModel = this.accountApiUsage_template.getViewModelForRequest();
        let baseApiUrl = '/api/settings/api/get';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }

    protected onDataRequestReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.updateApiKey(responseParsed.apiKey);
                obj.updateApiKeyEnabled(responseParsed.apiKeyEnabled);
                obj.updateApiCode(responseParsed.apiCode);
                obj.updateIsLoaded();
            });

            obj.loadingOut(obj.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));
        };
    }

    public getListDataForCSV(): void {

        this.loadingIn(this.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.accountApiUsage_template.getViewModelForRequest();

        subViewModel['csvExport'] = true;

        let baseApiUrl = '/api/settings/api/get/apiLogTableData/';

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdl = new XMLHttpRequestHandler(baseApiUrl,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onCSVDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onCSVDataRequestReturn(req, obj) {

        return function () {

            if(req.request.readyState == 4){

                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.exportCsvData(responseParsed);
                    obj.loadingOut(obj.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));
                }
            }
        };
    }

    protected exportCsvData(exportData): void{

        this.accountApiUsage_template.setCsvExportData(exportData);
        this.accountApiUsage_template.exportCsvData();
    }

    public getLogsTable(resetPagination: boolean = true): void {

        if (resetPagination) {

            this.accountApiUsage_template.getTemplateViewModel().pagination.pageNumber(1);
        }

        this.loadingIn(this.accountApiUsage_template.builtTemplate.querySelector("#apiLogs-results"), true);

        let subViewModel = this.accountApiUsage_template.getViewModelForRequest();
        let baseApiUrl = '/api/settings/api/get/apiLogTableData/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onGetLogsTableReturn.bind(this, baseApiUrl, 'getLogsTable'), XMLHttpRequestHandler_requestType.GET, 'getLogsTable')
    }

    protected onGetLogsTableReturn(baseApiUrl, callIdentifier, req, obj) {

        return function (){

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.setResultInfo(baseApiUrl, callIdentifier, responseParsed.totalCount, responseParsed.totalPage);
                obj.accountApiUsage_template.getTemplateViewModel().apiLogTableData(responseParsed.data);
                obj.accountApiUsage_template.pagination.setNumberItemToPaginate(responseParsed.totalCount);

                obj.loadingOut(obj.accountApiUsage_template.builtTemplate.querySelector("#apiLogs-results"), true);
            })
        }
    }

    public getLogsGraph(){

        this.loadingIn(this.accountApiUsage_template.builtTemplate.querySelector("#apiLogs-graph"), true);

        let subViewModel = this.accountApiUsage_template.getViewModelForRequest();
        let baseApiUrl = '/api/settings/api/get/apiLogGraphData/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onGetLogsGraphReturn, XMLHttpRequestHandler_requestType.GET, 'get')
    }

    protected onGetLogsGraphReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.accountApiUsage_template.setApiLogGraphData(responseParsed);

                obj.loadingOut(obj.accountApiUsage_template.builtTemplate.querySelector("#apiLogs-graph"), true);
            })
        }
    }

    public filterMultipleSelectorOnChange(idElement){

        this.getLogsTable();
        this.getLogsGraph();
    }

    public filterDateOnChange(element){

        this.getLogsTable();
        this.getLogsGraph();
    }

    private getXHRHdl(baseURl, callIdentifier){

        let callKey =   baseURl + '-' + callIdentifier;

        return this.XHRHdls[callKey];
    }

    protected setResultInfo(baseApiUrl, callIdentifier, totalCount, totalPage){

        let callHdl = this.getXHRHdl(baseApiUrl, callIdentifier);

        let execTime = Math.round((new Date().getTime() - callHdl.requestStartTime)/1000*100)/100;
        this.accountApiUsage_template.setResultPage(totalCount, totalPage, execTime);
    }

    public filterSingleGroupSelectorOnChange(element){

        if(element == 'endpointDropdown'){

            this.getLogsTable();
            this.getLogsGraph();
        }
    }

    public paginationOnPageClick(){

        this.getLogsTable(false);
    }

    protected updateApiKey(apiKey){

        this.accountApiUsage_template.setApiKey(apiKey);
    }

    protected updateApiKeyEnabled(apiKeyEnabled){

        this.accountApiUsage_template.setApiKeyEnabled(apiKeyEnabled);
    }

    protected updateApiCode(apiCode){

        this.accountApiUsage_template.setApiCode(apiCode);
    }

    protected updateIsLoaded(){

        this.accountApiUsage_template.setIsLoaded();
    }

    protected onGenerateApiKey() {

        this.loadingIn(this.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));

        let subViewModel = this.accountApiUsage_template.getViewModelForRequest();

        let accountApiUsageReq_url: string = '/api/settings/api/generate';
        let accountApiUsageReq_params: Array<Array<string>> = [];
        accountApiUsageReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(accountApiUsageReq_url, accountApiUsageReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onGenerateApiKeyReturn;
        this.XHRHdl.execute();
    }

    protected onGenerateApiKeyReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateApiKey(responseParsed.apiKey);
                obj.updateApiCode(responseParsed.apiCode);
            });


            obj.loadingOut(obj.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));
        };
    }

    protected onEnableApiKey() {

        this.loadingIn(this.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));

        let subViewModel = this.accountApiUsage_template.getViewModelForRequest();

        let accountApiUsageReq_url: string = '/api/settings/api/enable';
        let accountApiUsageReq_params: Array<Array<string>> = [];
        accountApiUsageReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(accountApiUsageReq_url, accountApiUsageReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onEnableApiKeyReturn;
        this.XHRHdl.execute();
    }

    protected onEnableApiKeyReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateApiKeyEnabled(responseParsed.apiKeyEnabled);
                obj.updateApiCode(responseParsed.apiCode);
            });

            obj.loadingOut(obj.accountApiUsage_template.builtTemplate.querySelector("#accountApiUsage-results"));
        };
    }

    public copyToClipboardNotification(){

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Copied to clipboard");
        this.getVnAppZone().showNotificationToModule();
    }
}



// WEBPACK FOOTER //
// ./js/modules/accountApiUsage.ts